import { Link } from 'react-router'
import { ArrowBack } from '../Icons'
import { Button, type ButtonProps } from './mui'

interface BackButtonProps extends ButtonProps {
  to: string
}

export function BackButton({ to, sx, ...props }: BackButtonProps) {
  return (
    <Button
      component={Link}
      to={to}
      variant='text'
      startIcon={<ArrowBack sx={{ color: 'neutral.main' }} />}
      sx={{ width: 'fit-content', typography: 'smallBody1', ...sx }}
      {...props}
    />
  )
}
